import axios from "axios";
import Globais, { validateToken } from "../../components/Globais";

export async function criarAssinaturaCTU(formData: any) {
  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/assinatura`;

    try {
      const response = await axios.post(URL, formData, {
        headers: { Authorization: Token.AuthStr },
      });
      console.log("[Anúncio de venda] Resposta da criação de assinatura", {
        status: response.status,
        data: response.data,
      });
      if (response) {
        return response.data.status;
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error("[Anúncio de venda] Erro ao criar assinatura", {
          status: error.response?.status,
          data: error.response?.data,
          url: URL,
        });
      } else {
        console.error("[Anúncio de venda] Erro ao criar assinatura", error);
      }
      return false;
    }
  } else {
    document.location.href = "/login";
    return false;
  }
}
export async function buscarAssinaturaPorStatus(status: string) {
  const formData = {
    status: status,
  };

  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/assinatura/pesquisa/status`;

    try {
      const response = await axios.post(URL, formData, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response) {
        return response.data;
      } else {
        return null;
      }
    } catch (e) {
      console.log(e);
      return false;
    }
  } else {
    document.location.href = "/login";
    return false;
  }
}

export async function buscarAssinaturaPorCotaUsuario(cotaUsuario: number) {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/assinatura`;
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        // Filtrar as assinaturas  pelo cotaUsuario
        const assinaturasFiltradas = response.data.filter(
          (assinatura: any) => assinatura.cotasUsuariosId === cotaUsuario
        );

        if (assinaturasFiltradas.length > 0) {
          return true;
        } else {
          return null;
        }
      } else {
        return null;
      }
    } catch (e) {
      console.log(e);
      return false;
    }
  } else {
    document.location.href = "/login";
    return false;
  }
}
